/* eslint-disable */
require('./account-icon')
require('./account')
require('./arrow-right')
require('./atm')
require('./bar')
require('./bike-c')
require('./bike-colored')
require('./bike')
require('./bus-c')
require('./bus-colored')
require('./bus')
require('./cafe')
require('./calendar-checked')
require('./calendar')
require('./car-c')
require('./car-club-c')
require('./car-club-colored')
require('./car-club')
require('./car-colored')
require('./car')
require('./chevron-down')
require('./chevron-up')
require('./circle-question-mark')
require('./clock')
require('./Consession')
require('./convenience_store')
require('./cross')
require('./currency-pound')
require('./current-location')
require('./cycle')
require('./dots')
require('./dotted-line-lg')
require('./dotted-line')
require('./drt-c')
require('./drt')
require('./email')
require('./ev_charge')
require('./ev-charge')
require('./eye-blocked')
require('./eye')
require('./ferry-c')
require('./ferry-colored')
require('./ferry')
require('./forward')
require('./from-to-arrows-small-icon')
require('./gas_station')
require('./house')
require('./journey')
require('./location')
require('./logo-full')
require('./logo')
require('./lowest-emissions')
require('./map')
require('./meal_takeaway')
require('./movie_theater')
require('./museum')
require('./park')
require('./phone_red')
require('./phone')
require('./pricing')
require('./print')
require('./question-mark')
require('./restaurant')
require('./Restaurants')
require('./route')
require('./shopping_mall')
require('./sort')
require('./star')
require('./subway-c')
require('./subway-colored')
require('./subway')
require('./supermarket')
require('./switch-from-to-icons')
require('./taxi-c')
require('./taxi-colored')
require('./taxi')
require('./three-dots')
require('./ticket')
require('./time-picker-calendar-icon')
require('./toilets')
require('./train-c')
require('./train-colored')
require('./train')
require('./tram-c')
require('./tram-colored')
require('./tram')
require('./virus')
require('./walk-c')
require('./walk-colored')
require('./walk')
